import { Injectable } from '@angular/core';
import { CanActivate, Router ,CanLoad} from '@angular/router';
import { AuthService } from './core';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {}

  public canActivate() {

    if (this.authService.isAuth()) {
        return true;
    } else {
        this.router.navigateByUrl('login');
        return false;
    }
  }
}

@Injectable()
export class AuthGuardLoad implements CanLoad {

  constructor( private authService: AuthService,private router: Router) {}

  public canLoad(): boolean {

    if (this.authService.isAuth()) {
        return true;
    } else {
        this.router.navigateByUrl('login');
        return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/auth.guard.ts